import qs from "query-string";
import { useLocation } from "react-router-dom";

export const useLoggedOutExperience = () => {
  const location = useLocation();
  const isLoggedOutUserExperience = !!qs.parse(location?.search ?? "")
    ?.loggedOut;

  return {
    isLoggedOutUserExperience,
  };
};
